import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBTable, MDBTableBody, MDBTableHead, MDBIcon } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button,   Select, Icon, message, Tag, Badge, Tooltip, Descriptions   } from 'antd';
import { api, URL } from '../../api';
import Swal from 'sweetalert2/dist/sweetalert2.js'

export default class Modelteacheraddstudentshort extends Component {


    constructor(props) {
              super(props);
      this.state = {
        modal: false,
        
        idcuriculum:'',
        Studentcb_Citizen_ID:'',
        studentlist:[],

        idcuriculumshort:'',
        Shortcourse_ID:'',
      }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onTextChange = this.onTextChange.bind(this);
    this.getcheckandregister = this.getcheckandregister.bind(this);
    this.getCurriculumstudentlist = this.getCurriculumstudentlist.bind(this);
    }


            toggle = () => {
                this.setState({
                modal: !this.state.modal
                });
              //  this.setState({ Citizen:this.props.Citizen})
                this.setState({ idcuriculumshort:this.props.idcuriculum}) 
                 this.setState({ Shortcourse_ID:this.props.Shortcourse_ID}) 
              //  this.getCurriculumstudentlist();
                this.setState({ Studentcb_Citizen_ID:''}) 
            }

            onTextChange = (e) => {
                this.setState({ [e.target.name]: e.target.value })
              }



            getCurriculumstudentlist() {
                setTimeout(() => {
                    api.get('index/getCurriculumstudentlist/'+this.state.idcuriculum,
                            
                            {headers: {
                        
                            }
                            })
                            //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                            .then(res => {
                            // console.log(res.data[0].id)
                            //  console.log(res.data)
                            //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                            //  console.log(Course)
                        
                                const studentlist = res.data;
                                this.setState({ studentlist });
                     }) 
               
                 }, 0);
            }


            handleSubmit() {
                // alert('A name was submitted: ' + this.state.value);
               setTimeout(() => {           
                  const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                  datafrm.append("idcuriculumshort", this.state.idcuriculumshort);
                  datafrm.append("Studentcb_ID", this.state.Studentcb_ID);
                  datafrm.append("Studentcb_Citizen_ID", this.state.Citizen);
                  
                  api.post("index/AddregisterCurriculum/",datafrm,{
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                   })
            
               .then(res => {
                //    console.log(res);
                    if (res.status === 200) {
                    //  alert("บันทึกสำเร็จ")
                              Swal.fire({
                                  title: 'ลงทะเบียนสำเร็จ',
                                  icon: 'success',
                                // showCancelButton: true,
                                  confirmButtonText: 'ตกลง',
                                // cancelButtonText: 'No, keep it'
                                }).then((result) => {
                                
                                })
                             }
                    })

                 //   this.getregisterCurriculum();
                   // this.toggle()
                  //  this.props.getclassroom()
            }, 1000);
            
            //window.location.href = '/Curriculum'
            //this.props.updateat();
            //this.getExpert()
             
              }


        //ดึงนักศึกษาที่ลงทะเบียนมีหรือไม่ หากมีให้บันทึกลงทะเบียน
        getcheckandregister() {
            setTimeout(() => {
               //ภายใน
               api.get('index/studentsearchforadd/'+this.state.Studentcb_Citizen_ID,
               {headers: {
            
               }
               })
               //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
               .then(res => {
               // console.log(res.data[0].id)
               //  console.log(res.data)
               //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
               //  console.log(Course)
                //  const studentlist = res.data;
                  // this.setState({ studentlist });

                  if (res.data.length !== 0) {
                    console.log(res.data[0].Studentcb_Citizen_ID)

                    const Studentcheck = this.state.studentlist.filter( ({ Studentcb_ID }) => Studentcb_ID >= res.data[0].Studentcb_ID );
                               // if (Studentcheck.length === 0) {
                                     
                                                setTimeout(() => {
                                                    const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                                                    datafrm.append("Shortcourse_ID", this.state.Shortcourse_ID);
                                                    datafrm.append("Shortcoursemd_ID", this.state.idcuriculumshort);
                                                    datafrm.append("Studentcbmd_ID", res.data[0].Studentcb_ID);
                                                    datafrm.append("Studentcbmd_Citizen_ID", this.state.Studentcb_Citizen_ID);
                                                    
                                                    api.post("index/AddregisterCurriculumshort/",datafrm,{
                                                        headers: {
                                                            'content-type': 'multipart/form-data'
                                                        }
                                                    })
                                            
                                                   .then(res => {
                                                   //    console.log(res);
                                                    if (res.status === 200) {
                                                    //  alert("บันทึกสำเร็จ")
                                                                Swal.fire({
                                                                    title: 'เพิ่มผู้เรียนสำเร็จ',
                                                                    icon: 'success',
                                                                // showCancelButton: true,
                                                                    confirmButtonText: 'ตกลง',
                                                                // cancelButtonText: 'No, keep it'
                                                                }).then((result) => {
                                                                    if (result.isConfirmed) {
                                                                        //  Swal.fire('Saved!', '', 'success')
                                                                        this.props.stulist();
                                                                        this.toggle();

                                                                        } else if (result.isDenied) {
                                                                         // Swal.fire('Changes are not saved', '', 'info')
                                                                        }
                                                                })
                                                            }
                                                            

                                                    })
                                
                                                  //  this.getregisterCurriculum();
                                                    // this.toggle()
                                                    //  this.props.getclassroom()
                                            }, 1000);



                                // }else{
                                //     Swal.fire({
                                //         title: 'เลขประจำตัวประชาชนนี้ ลงทะเบียนในหลักสูตรนี้แล้ว',
                                //         text: "กรุณาตรวจสอบอีกครั้ง",
                                //         icon: 'warning',
                                //       // showCancelButton: true,
                                //         confirmButtonText: 'ตกลง',
                                //       // cancelButtonText: 'No, keep it'
                                //       }).then((result) => {
                                      
                                //       })
                                // }


                  } else {
                        Swal.fire({
                            title: 'เลขประจำตัวประชาชนนี้ยังไม่ได้ลงทะเบียน',
                            text: "กรุณาลงทะเบียนหรือตรวจสอบอีกครั้ง",
                            icon: 'warning',
                          // showCancelButton: true,
                            confirmButtonText: 'ตกลง',
                          // cancelButtonText: 'No, keep it'
                          }).then((result) => {
                          
                          })
                  }
                }) 
  
             }, 0);
        }






            componentDidMount() {

                const { idcuriculum } = this.props.idcuriculum
                this.setState({ idcuriculumshort:this.props.idcuriculum}) 


                //console.log(this.props.Curriculumopen_ID);
              //  this.setState({ Curriculumopen_ID:this.props.Curriculumopen_ID}) 
               //  this.setState({ Curriculumopen_Full_Name_TH:this.props.Curriculumopen_Full_Name_TH}) 
               // this.setState({ Curriculumopen_Full_Name_TH:this.props.Curriculumopen_Full_Name_TH})
               // this.setState({ Citizen:this.props.Citizen})
               
              
                          api.get('index/getCurriculumstudentlist/'+this.props.Curriculumopen_ID,
                          //  Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/`+localStorage.getItem('Univ_ID'),
                          //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                          {headers: {
                          // Authorization: 'Bearer ' + localStorage.getItem('myData')
                          }
                          })
                          //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                          .then(res => {
                          // console.log(res.data[0].id)
                          //  console.log(res.data)
                          //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                          //  console.log(Course)
                     
                             const studentlist = res.data;
                              this.setState({ studentlist });
                           }) 
             //  this.getteacherforcurriculum();
                }


    render() {
     //   console.log(this.state.Studentcb_Citizen_ID)
        return (
            <>
               
                    <MDBBtn onClick={this.toggle} color="primary" >เพิ่มผู้เรียน</MDBBtn>

                    <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
                    <MDBModalHeader toggle={this.toggle}><MDBIcon far icon="calendar-plus" /> เพิ่มผู้เรียนในหลักสูตรระยะสั้น </MDBModalHeader>
                   
                        <MDBModalBody>
                            {/* {this.props.Citizen} */}
                            <MDBContainer className="text-left">
                            {/* <h5>หลักสูตร {this.state.Curriculumopen_Full_Name_TH}</h5>   */}

                             <div className="form-group">
                                            <label htmlFor="example2">ใส่เลขประจำตัวประชาชน 13 หลัก</label><br/>
                                            <Input showCount maxLength={13} minLength={13} placeholder="เลขประจำตัวประชาชน 13 หลัก" value={this.state.Studentcb_Citizen_ID} name="Studentcb_Citizen_ID" onChange={this.onTextChange}  style={{ width: "50%" }} required  /> <Button onClick={this.getcheckandregister} type="primary">เพิ่มผู้เรียน</Button> 
                                            {/* <input type="text" id="example2" placeholder="เลขประจำตัวประชาชน 13 หลัก" className="form-control form-control-md" value={this.state.Studentcb_Citizen_ID} name="Studentcb_Citizen_ID" onChange={this.onTextChange} required  /> */}
                              </div>


                            </MDBContainer>


                            

                             {/* <MDBTable>
                                <MDBTableHead>
                                    <tr>
                                    <th>ลำดับ</th>
                                    <th>ชื่อ</th>
                                    <th>นามสกุล</th>
                                    <th>เบอร์โทร</th>
                                    <th>e-mail</th>
                                    </tr>
                                </MDBTableHead>
                                <MDBTableBody>
                                    {this.state.studentlist.map((studentlist,index) =>{ 
                                    return  <tr>
                                                <td>{index+1}</td>
                                                <td>{studentlist.FULLNAME}{studentlist.Studentcb_NAME}</td>
                                                <td>{studentlist.Studentcb_LASTNAME}</td>
                                                <td>{studentlist.Studentcb_TEL}</td>
                                                <td>{studentlist.Studentcb_EMAIL}</td>
                                            </tr>
                                    } )}
                                   
                                    
                                </MDBTableBody>
                             </MDBTable> */}


                           
                             
                        </MDBModalBody>
                        <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                        {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
                        </MDBModalFooter>
                    </MDBModal>
               
            </>
        )
    }
}
